import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const LinkedAccountsSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Tab header placeholder */}
    <View style={styles.tabRow}>
      <SkeletonBone width={80} height={30} borderRadius={15} />
      <SkeletonBone width={90} height={30} borderRadius={15} />
    </View>

    {/* Linked account cards */}
    <SkeletonList count={3} gap={12}>
      <SkeletonCard>
        <SkeletonListItem avatar avatarSize={44} lines={2} lineWidths={[140, 100]} />
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
  },
  tabRow: {
    flexDirection: 'row',
    gap: 8,
  },
});
